











import { Component, Mixins, Prop } from "vue-property-decorator";
import { RawLocation, Route } from "vue-router";
import { DomainRegistry } from "../../domain";
import { UnmanagedLoginView } from "../authentication";

@Component({
  components: {
    UnmanagedLoginView,
  },
})
export default class GuestWizardLinkedDocumentEditView extends Mixins() {
  @Prop()
  userCode: string;

  @Prop()
  departmentCode: string;

  @Prop()
  hostName: string;

  @Prop()
  shouldAuthenticateLater: boolean;

  @Prop()
  patientNo: string;

  @Prop()
  systemKey: string;

  @Prop()
  linkKey: string;

  @Prop()
  shouldSelectDepartment: boolean;

  async beforeEnter(to: Route): Promise<RawLocation> {
    const id = await this.getLinkedDocumentId(this.systemKey, this.linkKey, this.patientNo);
    return id
      ? {
        path: "/Wizard/Guest/EditDocument",
        replace: true,
        query: {
          patientNo: to.query.patientNo,
          documentId: id.toString(),
          orderNo: to.query.linkKey,
          registeredMessage: to.query.registeredMessage,
        },
      }
      : {
        path: "/Wizard/Guest/EditNewDocument",
        replace: true,
        query: {
          patientNo: to.query.patientNo,
          formatId: to.query.formatId,
          chainedFormatId: to.query.chainedFormatId,
          chainedFormatIds: to.query.chainedFormatIds,
          institutionNo: to.query.institutionNo,
          regionalInstitutionNo: to.query.regionalInstitutionNo,
          hisInfoGetterParameter: to.query.hisInfoGetterParameter,
          systemKey: to.query.systemKey,
          linkKey: to.query.linkKey,
          orderNo: to.query.linkKey,
          registeredMessage: to.query.registeredMessage,
        }
      };
  }

  private async getLinkedDocumentId(systemKey: string, linkKey: string, patientNo: string): Promise<number> {
    const repository = DomainRegistry.collaboration.getLinkedDocumentRepository();
    return repository.getDocumentId(systemKey, linkKey, patientNo);
  }
}
